import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';

const ProtectedImage = ({ uuid, alt, className, onError }) => {
  const { accessToken, guestToken } = useAuthStore();
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = accessToken || guestToken;

    if (!uuid || !token) {
      setLoading(false);
      return;
    }

    const fetchImage = async () => {
      try {
        setLoading(true);
        setError(false);

        const response = await fetch(`/api/media/${uuid}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to load image');
        }

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        setImageSrc(objectUrl);
      } catch (err) {
        console.error('Failed to load protected image:', err);
        setError(true);
        if (onError) onError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();

    // Cleanup object URL on unmount
    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [uuid, accessToken, guestToken]);

  if (loading) {
    return (
      <div className={`bg-gray-200 dark:bg-gray-700 animate-pulse ${className}`} />
    );
  }

  if (error || !imageSrc) {
    return (
      <div className={`bg-gray-300 dark:bg-gray-600 flex items-center justify-center ${className}`}>
        <svg className="w-1/2 h-1/2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    );
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
    />
  );
};

export default ProtectedImage;
